import React from 'react';
import { motion } from 'framer-motion';

const FinalCTA = ({ onRegisterClick }) => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-6xl font-bold text-white mb-8 leading-tight">
              Fix Your Business <span className="text-yellow-400">Once</span>
            </h2>
            <p className="text-2xl md:text-3xl text-gray-300 mb-12">
              — Instead of Struggling Every Month
            </p>

            <div className="bg-gradient-to-r from-gray-800/50 to-gray-700/50 border border-blue-400/30 rounded-2xl p-8 mb-12 backdrop-blur-sm">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
                <div>
                  <p className="text-yellow-400 font-bold text-lg mb-2">Only LIVE.</p>
                  <p className="text-gray-400">Real-time interaction</p>
                </div>
                <div>
                  <p className="text-red-400 font-bold text-lg mb-2">No recordings.</p>
                  <p className="text-gray-400">Exclusive access</p>
                </div>
                <div>
                  <p className="text-green-400 font-bold text-lg mb-2">Action-driven sessions.</p>
                  <p className="text-gray-400">Immediate results</p>
                </div>
              </div>
            </div>

            <motion.button
              initial={{ scale: 1 }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={onRegisterClick}
              className="bg-gradient-to-r from-red-600 to-red-500 hover:from-red-700 hover:to-red-600 text-white text-2xl md:text-3xl font-bold py-8 px-16 rounded-full shadow-2xl transition-all duration-300 mb-8"
            >
              🔴 Register FREE for the 4-Day LIVE Workshop
            </motion.button>

            <p className="text-red-300 text-lg font-semibold">
              ⏰ Seats close automatically once timer ends.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;